const MySettingsIndex = () => import(/* webpackChunkName: "my-settings" */ '@/pages/mySettings/MySettingsIndex.vue')

export default [
  {
    path: '/my-settings',
    name: 'MySettings',
    component: MySettingsIndex
  }
]
